import Controller from '@ember/controller';

export default class MobileHomeIndexController extends Controller {
	override queryParams = ['theme']; // To support passing query parameter theme when transitioning
}
